module.exports = __webpack_public_path__ + "img/skip-icon.ba919959.svg";